/*
 * @Author: Ning
 * @Date: ****** 13:23:08
 * @LastEditTime: 2020-09-09 14:38:05
 * @LastEditors: Ning
 * @Description: System Logs 日志
 * @Do not edit
 */

import Home from "../pages/Home";
import Project from "../pages/Project";
import CityList from "../pages/CityList";
import Areatoraise from "../pages/Areatoraise";
import Personal from "../pages/Personal";
import Policy from "../pages/Policy";
import WorkGuide from "../pages/WorkGuide";
import Belows from "../components/common/Belows";
import AboutUs from "../pages/AboutUs";

 let routers = [
    {path:"/", name:"home", component:Home, title:'首页',views:true},
    {path:"/home", name:"home", component:Home, title:'首页',views:true},
    {path:"/project", name:"project", component:Project, isLogin:true, title:'房源项目',views:true},
    {path:"/citylist", name:"citylist", component:CityList, isLogin:true, title:'地图找房',views:true},
    // {path:"/areatoraise", name:"areatoraise", component:Areatoraise, isLogin:true, title:'区筹资格证申请',views:false},
    {path:"/belows", name:"belows", component:Belows, isLogin:true, title:'房源项目详情',views:true},
    {path:"/personal", name:"personal", component:Personal, isLogin:true, title:'个人中心',views:false},
    {path:"/policy", name:"policy", component:Policy, title:'政策法规',views:true},
    {path:"/workGuide", name:"workGuide", component:WorkGuide, title:'办事指南',views:true},
    {path:"/aboutUs", name:"aboutUs", component:AboutUs, title:'关于我们',views:true},
]

export default routers
